module.exports = __webpack_public_path__ + "img/core_m_2.85d6978e.png";